import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';

import {
    FETCH_PROGRAMS_PROGRESS_FAILED,
    FETCH_PROGRAMS_PROGRESS_SUCCEEDED,
    ProgramsAction,
    UPDATE_PROGRAM_WEEK_REQUESTED,
} from '../actions/programsActions';
import { FetchedWeekProgress, ProgramsState, ProgramWeeksProgress } from '../models/programs';
import { programsDefaultState, programWeekIdByNumber } from '../models/programsData';

const defaultState: ProgramsState = programsDefaultState;

const normalizeFetchedWeeksProgress = (
    weeksProgress: FetchedWeekProgress[],
): ProgramWeeksProgress =>
    weeksProgress.reduce(
        (accW, weekProgress) => ({
            ...accW,
            [programWeekIdByNumber[weekProgress.number]]: {
                ...omit(weekProgress, ['pk', 'number']),
            },
        }),
        {},
    );

export const programs = (state: ProgramsState = defaultState, action: ProgramsAction) => {
    switch (action.type) {
        case FETCH_PROGRAMS_PROGRESS_SUCCEEDED: {
            const programsProgress = action.payload;

            if (isEmpty(programsProgress)) {
                return state;
            }

            return {
                ...state,
                programsProgress: programsProgress.reduce(
                    (acc, programProgress) => ({
                        ...acc,
                        [programProgress.programId]: normalizeFetchedWeeksProgress(
                            programProgress.weeksAvailability,
                        ),
                    }),
                    {},
                ),
                programsProgressFetched: true,
            };
        }
        case UPDATE_PROGRAM_WEEK_REQUESTED: {
            const { programId, weekNumber, currentStep } = action.payload;

            const weekId = programWeekIdByNumber[weekNumber];

            const programWeeksProgress = state.programsProgress[programId];
            const weekProgress = programWeeksProgress ? programWeeksProgress[weekId] : {};

            return weekProgress
                ? {
                      ...state,
                      programsProgress: {
                          ...state.programsProgress,
                          [programId]: {
                              ...programWeeksProgress,
                              [weekId]: {
                                  ...weekProgress,
                                  currentStep,
                              },
                          },
                      },
                  }
                : state;
        }
        case FETCH_PROGRAMS_PROGRESS_FAILED:
            return {
                ...state,
                programsProgressFetched: true,
            };
        default:
            return state;
    }
};
